module.exports = __webpack_public_path__ + "img/saas_02.7092af69.jpg";